// Canonical ordered list of tab display names per facility type.
// Source of truth: backend `document_order` written by the facility config's
// active document templates (see `case_service.process_case`). This module
// provides a frontend-side fallback / lookup for the Documents-stage tabs.

const TABS_BY_FACILITY = {
    ipr: ['HPI', 'Diagnosis'],
    ltach: ['HPI', 'Diagnosis'],
    home_health: ['Pre-SOC Eligibility Report', 'RN Pre-Visit Briefing', 'Diagnosis Codes'],
};

export function getReviewTabs(facilityType) {
    const key = (facilityType || 'ipr').toLowerCase();
    return TABS_BY_FACILITY[key] || TABS_BY_FACILITY.ipr;
}

// Persona → preferred default tab, by facility type. Roles are taken from
// `facilities/{facilityId}/members/{uid}.role` once that plumbing exists
// (deferred — see plan Task 13 note). For now callers pass role=null and
// the resolver falls back to the first tab from getReviewTabs.
const DEFAULT_TAB_BY_ROLE = {
    home_health: {
        case_manager: 'Pre-SOC Eligibility Report',
        intake_coordinator: 'Pre-SOC Eligibility Report',
        clinician: 'RN Pre-Visit Briefing',
        rn: 'RN Pre-Visit Briefing',
    },
};

export function getDefaultTabKey(facilityType, role) {
    const key = (facilityType || 'ipr').toLowerCase();
    const map = DEFAULT_TAB_BY_ROLE[key];
    if (map && role && map[role]) return map[role];
    const tabs = getReviewTabs(facilityType);
    return tabs[0] ?? null;
}
